import { getAuthHeaders } from './utils';


export const fetchUsers = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/users`, {
      headers: getAuthHeaders(),
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.message || 'Failed to fetch users');
    }

    return res.json();
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


export const addUser = async (email) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/users/add`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ email }),
    });

    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Error adding user');
    }
    return data;
  } catch (error) {
    console.error('Error adding user:', error);
    throw error;
  }
};


export const toggleAdmin = async (userId) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/users/toggle_admin/${userId}`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });

    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Error toggling admin');
    }
    return data;
  } catch (error) {
    console.error('Error toggling admin:', error);
    throw error;
  }
};


export const toggleCanBook = async (userId) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/users/toggle_canbook/${userId}`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });

    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Error toggling can book property');
    }
    return data;
  } catch (error) {
    console.error('Error toggling can book property:', error);
    throw error;
  }
};


export const deactivateUser = async (userId) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/users/deactivate/${userId}`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });

    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Error deactivating user');
    }
    return data;
  } catch (error) {
    console.error('Error deactivating user:', error);
    throw error;
  }
};


export const updateElectricCar = async (userId) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/users/electric_car/${userId}`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });

    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Error updating electric car status');
    }
    return data;
  } catch (error) {
    console.error('Error updating electric car status:', error);
    throw error;
  }
};


export const updateElectricCarSelf = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/users/electric_car/self`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });

    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Error updating electric car status');
    }
    return data;
  } catch (error) {
    console.error('Error updating electric car status:', error);
    throw error;
  }
};
